import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { Commande } from "../../models/commande.model";
import { CommandeFacadeService } from "./commande-facade.service";

@Injectable({ providedIn: "root" })
export class CommandeStoreService extends EntityStoreService<
  Commande,
  EntityMetadata,
  CommandeState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      commande: null,
    });
  }
}

export interface CommandeState extends EntityStoreState<CommandeFacadeService> {
  commande: Commande;
}
